import { fmtDate, fmtDateTime } from "@/lib/fmt";

export const openLead = (id) => id && window.open(`/crm?lead=${id}`, "_blank");
export const human = (s) => (s ? String(s).replace(/_/g, " ") : "");

export const LeadLink = ({ id, name, stage }) => (
  <span className="inline-flex items-baseline gap-1.5">
    {id ? <button className="font-medium hover:underline text-[var(--text)]" onClick={() => openLead(id)} data-testid={`desk-lead-${id}`}>{name || "lead"}</button> : <span className="font-medium">{name || "—"}</span>}
    {stage && <span className="text-[10px] uppercase tracking-wider text-[var(--text-faint)]">{stage}</span>}
  </span>
);

export function Late({ d }) {
  if (d == null) return <span className="text-[var(--text-faint)]">no due date</span>;
  if (d <= 0) return <span className="text-[var(--ok)]">on time</span>;
  return <span className="text-[var(--breach)]">{d} day{d > 1 ? "s" : ""} late</span>;
}

export function TaskLine({ t, extra }) {
  return (
    <div className="py-2 border-b border-[var(--border)] last:border-0 text-xs" data-testid={`desk-task-${t.task_id}`}>
      <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5 text-sm">
        <LeadLink id={t.lead_id} name={t.lead_name} stage={t.lead_stage} />
        <span className="text-[var(--text-dim)]">·</span>
        <span>{t.label || "task"}</span>
        {t.sop_task === false && <span className="text-[10px] text-[var(--text-faint)]">custom task</span>}
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-0.5 mt-0.5 text-[var(--text-dim)]">
        <span>Due {t.due ? fmtDate(t.due) : "—"}</span>
        {t.done_at && <span>Done {fmtDateTime(t.done_at)}</span>}
        {t.done_at && <Late d={t.days_late} />}
        {t.outcome && <span>Outcome: <span className="text-[var(--text)]">{human(t.outcome)}</span></span>}
      </div>
      {t.note ? <div className="mt-0.5">Note: <span className="text-[var(--text)]">“{t.note}”</span></div> : t.done_at && <div className="mt-0.5 text-[var(--text-faint)]">No note written</div>}
      {t.why && <div className="mt-0.5 text-[var(--breach)]">Why flagged: {t.why}</div>}
      {extra}
    </div>
  );
}
